import React, { useState } from "react";
import "./Play_Now_Game.css";
import WalletCard from "./WalletCard/WalletCard";
import GameTabs from "./GameTabs/GameTabs";
import TimerSection from "./TimerSection/TimerSection";
import Website_ugread from "../Common/Common_Component/Website_ugread/Website_ugread";
import Bet_Select_section from "./Bet_Select_section/Bet_Select_section";
import Inner_Header from "../Common/Common_Component/Inner_Header/Inner_Header";
import Game_tabs_Section from "./Game_tabs_Section/Game_tabs_Section";

function Play_Now_Game() {

  const [activeTab, setActiveTab] = useState({ id: "30", label: "30 Sec", option_id: 1 },);

  return (
    <div className="play_now_game">
      <Inner_Header />
      <section className="container">
        <div className="game_container">
          <WalletCard />
          <Website_ugread />
          <GameTabs activeTab={activeTab} setActiveTab={setActiveTab} />
          <TimerSection activeTab={activeTab} setActiveTab={setActiveTab} />
          <Bet_Select_section mainActiveTab={activeTab} />
          <Game_tabs_Section mainActiveTab={activeTab} />
        </div>
      </section>
    </div>
  );
}

export default Play_Now_Game;
